import { createCrudApi } from '../createCrudApi';

export type LabMatsGetParams = {
  limit?: number;
  offset?: number;
  autopsy_protocol?: number;
};

export type LabMats = {
  id: number;
  autopsy_protocol: number;
  femoral_blood_tubes: number | null;
  venous_sinus_blood_tubes: number | null;
  cardiac_cavity_blood_tubes: number | null;
  subclavian_blood_tubes: number | null;
  bladder_lavage_ml: number | null;
  organs: boolean;
  vitreous_humor: boolean;
  gastric_content: boolean;
  hair: boolean;
  meconium: boolean;
  urine: boolean;
  other_text: string;
  other_blood_text: string;
};

export type LabMatFormData = Partial<Omit<LabMats, 'id'>>;

export const LabMatsApi = () =>
  createCrudApi<LabMats, LabMatFormData, LabMatsGetParams>('/v1/lab-mats/');
